/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S7_Link_GizlilikInputs */

const tr_cerez_s7_link_gizlilik = /** @type {(inputs: Cerez_S7_Link_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik Politikası`)
};

const en_cerez_s7_link_gizlilik = /** @type {(inputs: Cerez_S7_Link_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const de_cerez_s7_link_gizlilik = /** @type {(inputs: Cerez_S7_Link_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzrichtlinie`)
};

const ru_cerez_s7_link_gizlilik = /** @type {(inputs: Cerez_S7_Link_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Cerez_S7_Link_GizlilikInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s7_link_gizlilik = /** @type {((inputs?: Cerez_S7_Link_GizlilikInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S7_Link_GizlilikInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s7_link_gizlilik(inputs)
	if (locale === "de") return de_cerez_s7_link_gizlilik(inputs)
	if (locale === "ru") return ru_cerez_s7_link_gizlilik(inputs)
	return tr_cerez_s7_link_gizlilik(inputs)
});